import store from "@/store/index";

export function permArrayFunc() {
  return store.getters["user/permissions"];
}

export function casePagePermission(permission) {
  let isShow = true;
  if (permArrayFunc().indexOf("case_all") <= -1) {
    if (permArrayFunc().indexOf(permission) <= -1) {
      isShow = false;
    }
  }
  return isShow;
}
